import React, { useEffect, useState } from "react";
import loaderGif from "../../../../../../assets/images/loader.gif";
import { Tooltip } from "react-tooltip";
import "../Publishers.css";

const PublishersList = ({
  tableData,
  getPublishers,
  updateStatus,
  search,
  loader,
  onSort,
  sortingColumn,
  sortingOrder,
  deletePublisher,
  selectedPublishersRole,
}) => {
  const publishersListData = (id) => {
    getPublishers(id);
  };

  return (
    <>
      <div className="table-responsive custom-table">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="srno">Sr. No.</th>
              <th className="partner"  onClick={() => onSort("geo_name")}>
                Geo{" "}
                {sortingColumn === "geo_name" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  />
                ) : (
                  <i className="fas fa-sort" />
                )}
              </th>
              <th className="partner" onClick={() => onSort("segment_name")}>
                Segment{" "}
                {sortingColumn === "segment_name" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  />
                ) : (
                  <i className="fas fa-sort" />
                )}
              </th>

              <th className="partner"  onClick={() => onSort("name")}>
                Name{" "}
                {sortingColumn === "name" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  />
                ) : (
                  <i className="fas fa-sort" />
                )}
              </th>

              <th className="partner"  onClick={() => onSort("url")}>
                URL{" "}
                {sortingColumn === "url" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  />
                ) : (
                  <i className="fas fa-sort" />
                )}
              </th>

              {/*
              <th className="partner"  onClick={() => onSort("app")}>
                App{" "}
                {sortingColumn === "app" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  />
                ) : (
                  <i className="fas fa-sort" />
                )}
              </th> 
              */}

              <th className="margin" onClick={() => onSort("avails")}>
                Avails{" "}
                {sortingColumn === "avails" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  />
                ) : (
                  <i className="fas fa-sort" />
                )}
              </th>

              <th className="margin" onClick={() => onSort("display_cpm")}>
                Display CPM{" "}
                {sortingColumn === "display_cpm" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  />
                ) : (
                  <i className="fas fa-sort" />
                )}
              </th>

              <th className="margin" onClick={() => onSort("video_cpm")}>
                Video CPM{" "}
                {sortingColumn === "video_cpm" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  />
                ) : (
                  <i className="fas fa-sort" />
                )}
              </th>

              <th className="margin" onClick={() => onSort("ctv_cpm")}>
                CTV CPM{" "}
                {sortingColumn === "ctv_cpm" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  />
                ) : (
                  <i className="fas fa-sort" />
                )}
              </th>

              <th className="status" onClick={() => onSort("status")}>
                Status{" "}
                {sortingColumn === "status" ? (
                  <i
                    className={`fas fa-sort-${
                      sortingOrder === "asc" ? "up" : "down"
                    }`}
                  />
                ) : (
                  <i className="fas fa-sort" />
                )}
              </th>

              <th className="status">Action</th>
            </tr>
          </thead>

          {!loader ? (
            <tbody>
              {tableData && tableData.length > 0 ? (
                tableData?.map((item, i) => (
                  <React.Fragment key={i}>
                    <tr>
                      <td>{i + 1}</td>
                      <td className="partner">{item?.geo_name}</td>
                      <td className="partner">{item?.segment_name}</td>
                      <td className="partner" style={{ whiteSpace: "pre-line" }}>
                        {item?.name?.trim() || "—"}
                      </td>
                      <td className="partner">{item?.url} </td>
                      {/* <td className="partner">{item?.app} </td> */}
                      <td className="margin">{item?.avails} </td>
                      <td className="margin">{item?.display_cpm}</td>
                      <td className="margin"> {item?.video_cpm} </td>
                      <td className="margin">{item?.ctv_cpm} </td>
                      <td className="text-center status">
                        <label className="custom-switch">
                          <input
                            type="checkbox"
                            checked={item?.status === 1}
                            onClick={() =>
                              updateStatus(item.id, item.status === 1 ? 0 : 1)
                            }
                          />
                          <span className="slider round"></span>
                        </label>
                      </td>
                      <td className="text-center status">
                        <div className="table-icons">
                          <i
                            className="fa-regular fa-pen-to-square green"
                            onClick={() => publishersListData(item?.id)}
                          ></i>
                          <i
                            className="fa-regular fa-trash-can red"
                            onClick={() => deletePublisher(item?.id)}
                            style={{ marginLeft: "10px", cursor: "pointer" }}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          ) : (
            <div className={`loader ${loader ? "show" : ""}`}>
              <label>
                <img src={loaderGif} alt="Loading..." />
              </label>
            </div>
          )}
        </table>
      </div>

      <Tooltip id="my-tooltip-inline" place="top" className="custom-tooltip" />
    </>
  );
};

export default PublishersList;
